import { Component } from '@angular/core';

@Component({
  selector: 'app-mentions-legales',
  standalone: true,
  imports: [],
  templateUrl: './mentions-legales.html',
  styleUrl: './mentions-legales.scss'
})
export class MentionsLegalesComponent {

}
